import React from 'react';
import { Pill } from '@mantine/core';
import { IconBrandGithub, IconLink } from "@tabler/icons-react";

const ProjectHero = ({ project }) => {
  const projectYear = project.date?.split(',')[1]?.trim() || 'N/A';

  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="project-hero">
      <h1 className="project-title">{project.title}</h1>
      <p className="project-description">{project.description}</p>
      
      <div className="project-meta-grid">
        <div className="meta-item">
          <span className="meta-label">Category</span>
          <span className="meta-value">{project.type || 'N/A'}</span>
        </div>
        <div className="meta-item">
          <span className="meta-label">Year</span>
          <span className="meta-value">{projectYear}</span>
        </div>
        <div className="meta-item tech-stack">
          <span className="meta-label">Tech Stack</span>
          <Pill.Group>
            {project.techStack?.map(tech => <Pill key={tech} size="sm">{tech}</Pill>)}
          </Pill.Group>
        </div>
        <div className="meta-item links">
          <span className="meta-label">Links</span>
          <div className="meta-links">
            {project.href && (
              <button className="meta-link-button" onClick={() => handleLinkClick(project.href)}>
                <IconBrandGithub size={18} />
                <span>GitHub</span>
              </button>
            )}
            {project.deployment && (
              <button className="meta-link-button" onClick={() => handleLinkClick(project.deployment)}>
                <IconLink size={18} />
                <span>Deployment</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectHero;
